module.exports = __webpack_public_path__ + "img/scene-office.20b8d7f1.jpg";